import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import React, { useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import DragIndicatorIcon from 'assets/images/Category/DragIndicatorIcon.png';
import CheckBoxInput from 'components/common/Input/CheckBoxInput';
import CaretUpIcon from 'assets/images/Category/CaretUp.png';
import CaretDownIcon from 'assets/images/Category/CaretDown.png';
import EditUnderlineIcon from 'assets/images/Category/editUnderlineIcon.png';
import DescriptionIcon from 'assets/images/Category/DescriptionIcon.png';
import DeleteIcon from 'assets/images/Category/DeleteIcon.png';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormattedMessage } from 'react-intl';
import CustomPopover from 'components/common/CustomPopover';

const SortableSubServiceList = ({
  services,
  onEdit,
  onCheckBoxEnableDisable,
  onDelete,
  onDragEnd, // new prop to update order
}) => {
  const [expanded, setExpanded] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [
    {
      label: <FormattedMessage id="Edit Service" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onEdit(viewData),
    },
    {
      label: <FormattedMessage id="Delete" />,
      icon: <Image src={DeleteIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onDelete(viewData),
    },
  ];

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={`sub-${services.id}`}>
          {(provided) => (
            <Row
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="m-0 p-0 mt-3"
            >
              {services?.sub_services.map((service, index) => (
                <Draggable
                  key={service.id}
                  draggableId={service.id.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <Row
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps} // drag handle here
                      className={`m-0 p-0  ${services?.sub_services?.length === index + 1 ? 'pt-4' : 'border-b py-4'}`}
                    >
                      {onEdit ? (
                        <Col md={6} className="items-center">
                          <div className="flex items-center gap-2">
                            <img
                              src={DragIndicatorIcon}
                              alt={'icon'}
                              style={{ height: '32px', width: '32px' }}
                            />
                            <CheckBoxInput
                              height={'32px'}
                              onChange={() => onCheckBoxEnableDisable(service)}
                              checked={service?.status}
                            />
                            {service.subServices?.length > 0 && (
                              <button
                                className="expand-btn text-lg"
                                onClick={() => toggleExpand(service.id)}
                                aria-label={`Toggle sub-services for ${service.name}`}
                              >
                                {expanded[service.id] ? (
                                  <img
                                    src={CaretDownIcon}
                                    alt={'icon'}
                                    style={{ height: '24px', width: '24px' }}
                                  />
                                ) : (
                                  <img
                                    src={CaretUpIcon}
                                    alt={'icon'}
                                    style={{ height: '24px', width: '24px' }}
                                  />
                                )}
                              </button>
                            )}
                            <>
                              {service?.sub_services?.services_image?.[0]
                                ?.url && (
                                <img
                                  src={
                                    service?.sub_services?.services_image?.[0]
                                      ?.url
                                  }
                                  alt="icon"
                                  style={{ height: '50px', width: '50px' }}
                                />
                              )}
                              <span className="service-name font-bold">
                                {service.name}
                              </span>
                            </>
                          </div>
                        </Col>
                      ) : (
                        <Col md={6} className="items-center">
                          <p className="service-name font-bold">
                            {service.product_name_en}
                          </p>
                        </Col>
                      )}

                      <Col md={3}>
                        <div className="flex items-center gap-5">
                          <span className="service-price text-gray-600">
                            {service.price} {service.currency}
                          </span>
                          <span className="service-time text-gray-600">
                            {service.time_required_in_mints} min
                          </span>
                        </div>
                      </Col>

                      {onEdit ? (
                        <Col md={3} className="">
                          <Stack
                            direction="horizontal"
                            gap={4}
                            className="items-center justify-end"
                          >
                            {/* <img
                  src={EditUnderlineIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                /> */}
                            <div>
                              <MoreVertIcon
                                aria-describedby={id}
                                style={{ fill: '#3C1053', cursor: 'pointer' }}
                                onClick={(e) => handlePopoverClick(e, service)}
                              />
                              <CustomPopover
                                id={id}
                                open={open}
                                anchorEl={anchorEl}
                                handleClose={handlePopoverClose}
                                options={PopoverData}
                              />
                            </div>
                          </Stack>
                        </Col>
                      ) : (
                        <Col md={3} className="text-end">
                          {service.subServices?.length > 0 && (
                            <button
                              className="expand-btn text-lg"
                              onClick={() => toggleExpand(service.id)}
                              aria-label={`Toggle sub-services for ${service.name}`}
                            >
                              {expanded[service.id] ? (
                                <img
                                  src={CaretDownIcon}
                                  alt={'icon'}
                                  style={{ height: '24px', width: '24px' }}
                                />
                              ) : (
                                <img
                                  src={CaretUpIcon}
                                  alt={'icon'}
                                  style={{ height: '24px', width: '24px' }}
                                />
                              )}
                            </button>
                          )}
                        </Col>
                      )}
                    </Row>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Row>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default SortableSubServiceList;
